import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MaskitoOptions } from '@maskito/core';
import { DateConversionUtils } from '../../../../../utils/date-conversion-utils';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class DateInputComponent implements ControlValueAccessor {
  @Input() placeholder: string = '';
  @Input() controlId: string | null = null;
  @Input() error: boolean = false;

  @Output() valueChanged = new EventEmitter<string | null>();

  public disabled: boolean = false;
  public value: string | null = null;

  public maskitoOptions: MaskitoOptions = {
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
  };

  public onChange = (_: any) => {};
  public onTouched = () => {};

  public handleInput(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.value = inputValue;
    this.onChange(inputValue);
    this.valueChanged.emit(inputValue);
  }

  public writeValue(obj: any): void {
    if (!!obj) {
      const [day, month, year] = obj.split('/');
      // Built with Date.UTC (not the local constructor) so it round-trips correctly through
      // DateConversionUtils.dateToShorthand, which reads back via the UTC getters.
      const date = new Date(Date.UTC(+year, +month - 1, +day));
      this.value = DateConversionUtils.dateToShorthand(date);
    } else {
      this.value = null;
    }
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
